import { Injectable, NgModule } from '@angular/core';
import { DataApiService, BaseService } from '@xpo-ltl/data-api';
import { ConfigManagerService, CONFIG_MANAGER_SERVICE_CONFIGURATION, ConfigManagerModule } from '@xpo-ltl/config-manager';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@xpo-ltl/data-api';
import * as ɵngcc2 from '@xpo-ltl/config-manager';
class AppMetadataApiService extends BaseService {
    /**
     * @param {?} dataApiService
     * @param {?} configManager
     */
    constructor(dataApiService, configManager) {
        super();
        this.dataApiService = dataApiService;
        this.configManager = configManager;
    }
    /**
     * Health check URL. Responds with success message if the service is running.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    healthCheck(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/health-check'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * List of resources.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    options(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/options'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * Details of user invoking the API.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    loggedInUser(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/appusers/logged-in-user'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation creates a new entry in the App Metadata table.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. Valid values which will be used to create the app must be provided.
     * <br/>
     * <br/>Post-condition:
     * <br/>1. If successful, then a new application record will be created in the table.
     * <br/>2. Otherwise an appropriate error message will be returned.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    createAppMetadata(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/apps'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation retrieves the metadata for an app.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. The name of the app is required.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, the minimum app version and list of list of supported browsers are returned.
     * <br/>2. Otherwise an appropriate eror message is returned.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getAppMetadata(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/apps/{appName}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation lists the applications that exist.
     * <br/>
     * <br/>Pre-conditions:
     * <br/>None
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the list of applications including details such as name, supported browsers, minimum app version, etc. is returned.
     * <br/>2. Otherwise an appropriate eror message is returned.
     * <br/>
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listApplications(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/applications'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * Performs an app global search and returns results for Shipment, Invoice, Claims, and/or Disputes.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. keyValueEntered is provided and valid.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If the value provided is valid and found, then results for Shipment, Invoice, Claims, and/or Disputes.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    performAppGlobalSearch(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/app-global-search/{searchTxt}'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation updates an existing entry in the App Metadata table.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. Valid values which will be used to update the app must be provided.
     * <br/>
     * <br/>Post-condition:
     * <br/>1. If successful, then the application record will be updated in the table.
     * <br/>2. Otherwise an appropriate error message will be returned.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    updateAppMetadata(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/apps'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * @return {?}
     */
    getEndPoint() {
        return this.configManager.getSetting(AppMetadataApiService.AppMetadataApiEndpoint);
    }
}
AppMetadataApiService.ɵfac = function AppMetadataApiService_Factory(t) { return new (t || AppMetadataApiService)(ɵngcc0.ɵɵinject(ɵngcc1.DataApiService), ɵngcc0.ɵɵinject(ɵngcc2.ConfigManagerService)); };
AppMetadataApiService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AppMetadataApiService, factory: AppMetadataApiService.ɵfac });
AppMetadataApiService.AppMetadataApiEndpoint = 'appmetadataApiEndpoint';
/** @nocollapse */
AppMetadataApiService.ctorParameters = () => [
    { type: DataApiService },
    { type: ConfigManagerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AppMetadataApiService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.DataApiService }, { type: ɵngcc2.ConfigManagerService }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
const ɵ0 = { configFileUrl: './assets/config.json' };
class SdkAppMetadataModule {
}
SdkAppMetadataModule.ɵfac = function SdkAppMetadataModule_Factory(t) { return new (t || SdkAppMetadataModule)(); };
SdkAppMetadataModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SdkAppMetadataModule });
SdkAppMetadataModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        AppMetadataApiService,
        { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: ɵ0 },
    ], imports: [[
            ConfigManagerModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SdkAppMetadataModule, [{
        type: NgModule,
        args: [{
                imports: [
                    ConfigManagerModule
                ],
                providers: [
                    AppMetadataApiService,
                    { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: ɵ0 },
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SdkAppMetadataModule, { imports: function () { return [ConfigManagerModule]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * AppMetadata API
 * Version: 1.0
 * Build: 1.0.1.12
 */
/**
 * Request to create a new application.
 */
class CreateAppMetadataRqst {
    constructor() {
        /**
         * Information that will be used to create a new application record.
         * Required: true
         * Array: false
         */
        this.application = undefined;
    }
}
/**
 * Path parameter used to retrieve app metadata.
 */
class GetAppMetadataPath {
    constructor() {
        /**
         * Required: true
         * Array: false
         */
        this.appName = undefined;
    }
}
/**
 * Contains information about an app such as minimum version, supported browsers and version etc.
 */
class GetAppMetadataResp {
    constructor() {
        /**
         * The name of the app
         * Required: false
         * Array: false
         */
        this.appName = undefined;
        /**
         * The minimum supported app version
         * Required: false
         * Array: false
         */
        this.minAppVersion = undefined;
        /**
         * List of supported browsers
         * Required: false
         * Array: true
         */
        this.supportedBrowsers = undefined;
    }
}
/**
 * List of applications
 */
class ListApplicationsResp {
    constructor() {
        /**
         * The list of applications that exist.
         * Required: false
         * Array: true
         */
        this.applications = undefined;
    }
}
/**
 * Path parameter for the request to perform an app global search.
 */
class PerformAppGlobalSearchPath {
    constructor() {
        /**
         * PRO number, Claims number or Disputes number are the expected key values for the first release.
         * Required: true
         * Array: false
         */
        this.searchTxt = undefined;
    }
}
/**
 * Query parameters for the request to perform an app global search.
 */
class PerformAppGlobalSearchQuery {
    constructor() {
        /**
         * The list of values which allow consumers to optionally indicate the type of data to be included in the response.
         * Required: false
         * Array: true
         */
        this.globalSearchDetailCds = undefined;
        /**
         * Pagination information to retrieve the list.
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 * Response to the request to perform an app global search.
 */
class PerformAppGlobalSearchResp {
    constructor() {
        /**
         * A list of global search results returned for the key value entered.
         * Required: false
         * Array: false
         */
        this.globalSearchResult = undefined;
        /**
         * Pagination information to retrieve the list.
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 * Request to update a new application.
 */
class UpdateAppMetadataRqst {
    constructor() {
        /**
         * Information that will be used to update an existing application record.
         * Required: true
         * Array: false
         */
        this.application = undefined;
    }
}
/**
 * Details about invoice search results.
 */
class ClaimSearchResult {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.pickupDt = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.claimId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.filingDt = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.claimantName = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.appName = undefined;
    }
}
/**
 * Details about invoice search results.
 */
class DisputeSearchResult {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.disputeId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.disputeType = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.disputeStatus = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.claimantName = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.inspectorName = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.debtorName = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.workflowItemInstId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.appName = undefined;
    }
}
/**
 * Details about DMS documents search results.
 */
class DocumentSearchResult {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.corpCode = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.docClass = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.docArchiveTimestamp = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.appName = undefined;
    }
}
/**
 * Details about a loaded trailer.
 */
class GlobalSearchResult {
    constructor() {
        /**
         * Search results relating to Shipment.
         * Required: false
         * Array: true
         */
        this.shipmentSearchResults = undefined;
        /**
         * Search results relating to Invoice.
         * Required: false
         * Array: true
         */
        this.invoiceSearchResults = undefined;
        /**
         * Search results relating to Claims.
         * Required: false
         * Array: true
         */
        this.claimSearchResults = undefined;
        /**
         * Search results relating to Disputes.
         * Required: false
         * Array: true
         */
        this.disputeSearchResults = undefined;
        /**
         * Search results relating to DMS documents.
         * Required: false
         * Array: true
         */
        this.documentSearchResults = undefined;
        /**
         * Search results relating to PnD.
         * Required: false
         * Array: true
         */
        this.pndSearchResults = undefined;
        /**
         * Search results relating to Pickup.
         * Required: false
         * Array: true
         */
        this.pickupSearchResults = undefined;
    }
}
/**
 * Details about invoice search results.
 */
class InvoiceSearchResult {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.pickupDt = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.invoiceDt = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.invoiceType = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.shipperName = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.consigneeName = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.billToName = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.appName = undefined;
    }
}
/**
 * Details about PND search results.
 */
class PnDSearchResult {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.routeInstId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.shipmentInstId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.tripInstId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.routePrefix = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.routeSuffix = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.routeDate = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.statusCd = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.categoryCd = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.shipmentPnDStatusCd = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.estimatedDeliveryDate = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.destinationSicCd = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.consignee = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.appName = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.shipmentLocationSicCd = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.dsrName = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.tripDate = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.tripStatusCd = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.tripTerminalSicCd = undefined;
    }
}
/**
 * Details about shipment search results.
 */
class ShipmentSearchResult {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.shipmentInstId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.pickupDt = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.shipperName = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.consigneeName = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.billToName = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.movementStatusCd = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.destinationSicCd = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.estimatedDeliveryDate = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.shipmentPnDStatusCd = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.routeInstId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.appName = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.hostDestSicCd = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.billInd = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.areaInstId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.routeTypeCd = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.deliveryQualifierCd = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.shipmentLocationSicCd = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.movementException = undefined;
        /**
         * Indicates whether the Shipment can be staged for PnD Route planning.
         * Required: false
         * Array: false
         */
        this.stageableInd = undefined;
        /**
         * Provides the reason for placing the shipment into a specific delivery qualifier status. The vlaues are specific to the qualifier code.
         * Required: false
         * Array: false
         */
        this.deliveryQualifierReasonCd = undefined;
    }
}
/**
 * Details about Pickup request search results.
 */
class PickupSearchResult {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.callNbr = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.pickupRequestInstId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.shipper = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.pickupDate = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.pickupStatusCd = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.pickupTypeCd = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.tripInstId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.bolInstId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.appName = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.pickupTerminalSicCd = undefined;
    }
}
/**
 * List of Applications for LTL (added 4/8/2019)
 */
class Application {
    constructor() {
        /**
         * A unique id for the application
         * Required: false
         * Array: false
         */
        this.applInstId = undefined;
        /**
         * Name of the application
         * Required: false
         * Array: false
         */
        this.applName = undefined;
        /**
         * Path to the application, not including the
         *
         * host
         * Required: false
         * Array: false
         */
        this.url = undefined;
        /**
         * The minimum supported
         *
         * version of the application.
         * Required: false
         * Array: false
         */
        this.minimumVersionNbr = undefined;
        /**
         * An image icon for the application
         * Required: false
         * Array: false
         */
        this.icon = undefined;
        /**
         * Group to which the application belongs. E.g. Ops , Audit  etc. Added 09/29/2021  LISG-15170
         * Required: false
         * Array: false
         */
        this.groupName = undefined;
        /**
         * Description of the application.   Added 09/29/2021  LISG-15170
         * Required: false
         * Array: false
         */
        this.applicationDescription = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         *
         * Required: false
         * Array: true
         */
        this.browser = undefined;
    }
}
/**
 * List of browsers for LTL (added 4/8/2019)
 */
class Browser {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.browserInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.browserName = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.versionNbr = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class InterfaceAcct {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.acctInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.acctMadCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.creditStatusCode = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.locationTypeCode = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.parentAcctInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.nationalAcctInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.name1 = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.name2 = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.addressLine1 = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.addressLine2 = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.cityName = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.stateCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.postalCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.countryCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.deletedInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lastCreatedBy = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lastCreatedDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.latitudeNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.longitudeNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.zip4RestUs = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.geoCoordinates = undefined;
        /**
         * Geo coordinations
         * Required: false
         * Array: false
         */
        this.geoCoordinatesGeo = undefined;
        /**
         * The value comes from SCO_CUSTOMER_PROFILE.LOCATION_TYPE_CD.
         *
         * The type of location
         *
         * Valid Values:
         * BusinessCommercialBUSINESS/COMMERCIAL
         * DistributionCenterDISTRIBUTION CENTER
         * GroceryWareHouseGROCERY WAREHOUSE
         * ShoppingMallSHOPPING MALL/STRIP MALL
         * UnversityCollegeUNIVERSITY/COLLEGE
         * ConstructionSiteCONSTRUCTION/UTILITY SITES: CONSTRUCTION SITE
         * ConstructionUtilitySiteCONSTRUCTION/UTILITY SITES: UTILITY SITE
         * GovtMineGOVERNMENT SITES: MINE
         * GovtGasOilFieldGOVERNMENT SITES: NATURAL GAS OR OIL FIELD
         * GovtPostOfficeGOVERNMENT SITES: POST OFFICE
         * GovtMilitaryGOVERNMENT SITES: MILITARY
         * GovtPrisonCorrectionGOVERNMENT SITES: PRISON/CORRECTION FACILITY
         * GovtAirportGOVERNMENT SITES: AIRPORT
         * GovtOtherGOVERNMENT SITES: OTHER GOVERNMENT SITES
         * PierContainerFreightStationPIERS, WHARFS, CFS: CONTAINER FREIGHT STATION
         * PierWharfPIERS, WHARFS, CFS: PIER OR WHARF
         * ResidentialHomeRESIDENTIAL: RESIDENCE
         * ResidentialApartmentRESIDENTIAL: APARTMENT
         * ResidentialPlaceofWorshipRESIDENTIAL: PLACE OF WORSHIP
         * ResidentialSchoolRESIDENTIAL: SCHOOL (K-12)
         * ResidentialCampRESIDENTIAL: CAMP
         * ResidentialFarmRESIDENTIAL: FARM
         * ResidentialPublicStorageRESIDENTIAL: PUBLIC STORAGE FACILITY
         * ResidentialBusinessRESIDENTIAL: BUSINESS OPERATING WITHIN A PRIVATE RESIDENCE
         * ExhibitionConvCtrEXHIBITION SITES: EXHIBITION SITE OR CONVENTION CENTER
         * Required: false
         * Array: false
         */
        this.customerProfileLocationTypeCd = undefined;
    }
}
/**
 * Holds a snapshot of InterfaceAcct. Contains the details at the time on an event. It also provides the previous values if an update occured
 * null
 */
class InterfaceAcctSnapshot {
    constructor() {
        /**
         * The action that created this snapshot. Add, Update or Delete
         * Required: false
         * Array: false
         */
        this.eventActionCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.acctInstId = undefined;
        /**
         * The previous snapshot, before this record was updated.
         * Required: false
         * Array: false
         */
        this.before = undefined;
        /**
         * The current snapshot.
         * Required: false
         * Array: false
         */
        this.after = undefined;
    }
}
/**
 *
 */
class Movement {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipmentInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.typeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.movementReportingSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.movementDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerLoadedSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerIdPrefix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerIdSuffixNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.rshpCreditedInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scacCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.deliveryQualifierCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.obcPickupDlvRouteCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.archiveControlCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.routePrefix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.routeSuffix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.qlfrReasonCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.customerLocationArrivalDateTime = undefined;
        /**
         * Unique identifier for the carrier that executed this movement.  Added 04/06/2021  LISG-11313
         * Required: false
         * Array: false
         */
        this.carrierId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         * Expanded Name : Movement status
         *
         * Desc : The status of the latest movement for a Shipment from an operations point-of-view. This is a denormalized atribute from the MOVEMENT entity.
         *
         * Source: MBF
         * Name: Various
         *
         * Valid Values :
         * Spaces - Not applicable
         * 1 - On dock
         * 2 - On trailer
         * 3 - Out for delivery
         * 4-  Interim Delivery
         * 5 - Final Delivered
         * 6 - Not Applicable
         * 6 - No movements allowed
         * 7 - Cancelled
         * Required: false
         * Array: false
         */
        this.movementStatusCd = undefined;
        /**
         *
         * Required: false
         * Array: true
         */
        this.movementException = undefined;
    }
}
/**
 *
 */
class MovementException {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipmentInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.movementSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.typeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.piecesCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.rfsdReasonCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.undlvdReasonCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dmgdCategoryCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.remarks = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.archiveControlCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.exceptionSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.exceptionReportingSicCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         *
         * Required: false
         * Array: true
         */
        this.movementExceptionAction = undefined;
    }
}
/**
 * Describes the action that is being taken for a shipment exception as well as the Service Center that is responsible for taking the action and the reason for the action.  Added 01/02/2020
 */
class MovementExceptionAction {
    constructor() {
        /**
         * Part of unique identifier
         * Required: false
         * Array: false
         */
        this.shipmentInstId = undefined;
        /**
         * Part of unique identifier
         * Required: false
         * Array: false
         */
        this.movementSequenceNbr = undefined;
        /**
         * Part of unique identifier
         * Required: false
         * Array: false
         */
        this.movementExceptionSequenceNbr = undefined;
        /**
         * Uniquely identifies a row
         * Required: false
         * Array: false
         */
        this.sequenceNbr = undefined;
        /**
         * Describes the action that is being taken for a shipment exception as well as the Service Center that is responsible for taking the action and the reason for the action.
         * Required: false
         * Array: false
         */
        this.reasonCd = undefined;
        /**
         * Responsible sic could be determined to be different from what SHM_movement has recorded
         * Required: false
         * Array: false
         */
        this.responsibleSicCd = undefined;
        /**
         * Describes what corrective action XPO has taken to address the exception. This is typically shared with the customer.
         * Required: false
         * Array: false
         */
        this.correctiveAction = undefined;
        /**
         * A unique identifier to correlate multiple Invoices. This is used as a batch# when reprint for Email is requested and they need to be processed as a group.
         * 	This is a value that API gateway assigns for a call. API then loops through creating multiple invoices with the same value
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Indicates whether the carrier was in a position to control or prevent the exception.  Added 03/23/2020 LISG-4722
         * Required: false
         * Array: false
         */
        this.controlInd = undefined;
    }
}
/**
 * Holds a snapshot of MovementExceptionAction. Contains the details at the time on an event. It also provides the previous values if an update occured
 * Describes the action that is being taken for a shipment exception as well as the Service Center that is responsible for taking the action and the reason for the action.  Added 01/02/2020
 */
class MovementExceptionActionSnapshot {
    constructor() {
        /**
         * The action that created this snapshot. Add, Update or Delete
         * Required: false
         * Array: false
         */
        this.eventActionCd = undefined;
        /**
         * Part of unique identifier
         * Required: false
         * Array: false
         */
        this.shipmentInstId = undefined;
        /**
         * Part of unique identifier
         * Required: false
         * Array: false
         */
        this.movementSequenceNbr = undefined;
        /**
         * Part of unique identifier
         * Required: false
         * Array: false
         */
        this.movementExceptionSequenceNbr = undefined;
        /**
         * Uniquely identifies a row
         * Required: false
         * Array: false
         */
        this.sequenceNbr = undefined;
        /**
         * The previous snapshot, before this record was updated.
         * Required: false
         * Array: false
         */
        this.before = undefined;
        /**
         * The current snapshot.
         * Required: false
         * Array: false
         */
        this.after = undefined;
    }
}
/**
 * Holds a snapshot of MovementException. Contains the details at the time on an event. It also provides the previous values if an update occured
 * null
 */
class MovementExceptionSnapshot {
    constructor() {
        /**
         * The action that created this snapshot. Add, Update or Delete
         * Required: false
         * Array: false
         */
        this.eventActionCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipmentInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.movementSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sequenceNbr = undefined;
        /**
         * The previous snapshot, before this record was updated.
         * Required: false
         * Array: false
         */
        this.before = undefined;
        /**
         * The current snapshot.
         * Required: false
         * Array: false
         */
        this.after = undefined;
    }
}
/**
 * Holds a snapshot of Movement. Contains the details at the time on an event. It also provides the previous values if an update occured
 * null
 */
class MovementSnapshot {
    constructor() {
        /**
         * The action that created this snapshot. Add, Update or Delete
         * Required: false
         * Array: false
         */
        this.eventActionCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipmentInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sequenceNbr = undefined;
        /**
         * The previous snapshot, before this record was updated.
         * Required: false
         * Array: false
         */
        this.before = undefined;
        /**
         * The current snapshot.
         * Required: false
         * Array: false
         */
        this.after = undefined;
    }
}
/**
 * Supported browsers by application (added
 *
 * 4/8/2019)
 */
class SupportedBrowser {
    constructor() {
        /**
         * A unique id for the
         *
         * application
         * Required: false
         * Array: false
         */
        this.applInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.browserInstId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { SdkAppMetadataModule, AppMetadataApiService, CreateAppMetadataRqst, GetAppMetadataPath, GetAppMetadataResp, ListApplicationsResp, PerformAppGlobalSearchPath, PerformAppGlobalSearchQuery, PerformAppGlobalSearchResp, UpdateAppMetadataRqst, ClaimSearchResult, DisputeSearchResult, DocumentSearchResult, GlobalSearchResult, InvoiceSearchResult, PnDSearchResult, ShipmentSearchResult, PickupSearchResult, Application, Browser, InterfaceAcct, InterfaceAcctSnapshot, Movement, MovementException, MovementExceptionAction, MovementExceptionActionSnapshot, MovementExceptionSnapshot, MovementSnapshot, SupportedBrowser };

